export { ContentPlatformImage as default } from "./content-platform-image";
